import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../core/authentication/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Declaración de tipo para ResizeObserver
declare const ResizeObserver: any;

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('fixedHeaderMenu') fixedHeaderMenu: ElementRef;
  url1: boolean = true;
  headerMenuHeight: number = 120;
  private destroy$ = new Subject<void>();
  private resizeObserver: any;

  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit() {
    // Verificar rutas especiales que no requieren autenticación
    if(this.router.url.includes('lead/newnoauth')){
      this.url1 = false;
      return;
    }

    // Suscribirse al estado de autenticación
    this.authService.authNavStatus$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isAuthenticated => {
        // Solo ocultar menú si no está autenticado y no está en rutas especiales
        if (!this.router.url.includes('lead/newnoauth')) {
          // Si detecta que no está autenticado, navegar a login
          // (a menos que ya esté en la página de login)
          if (!isAuthenticated) {
            this.url1 = false;
            if (!this.router.url.includes('/account/login') && 
                !this.router.url.includes('/auth-callback')) {
              this.router.navigate(['/account/login']);
            }
          } else {
            this.url1 = true;
          }
        }
      });

    // Verificar estado inicial de autenticación
    this.url1 = this.authService.isAuthenticated();
  }


  ngAfterViewInit() {
    // Calcular altura inicial después de que la vista esté completamente inicializada
    if (this.fixedHeaderMenu && this.url1) {
      setTimeout(() => {
        this.updateHeaderHeight();
        this.setupResizeObserver();
      }, 100);
    }
  }

  private setupResizeObserver() {
    if (this.fixedHeaderMenu && typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateHeaderHeight();
      });
      this.resizeObserver.observe(this.fixedHeaderMenu.nativeElement);
    }
  }

  private updateHeaderHeight() {
    if (this.fixedHeaderMenu && this.url1) {
      const newHeight = this.fixedHeaderMenu.nativeElement.offsetHeight;
      if (newHeight > 0 && newHeight !== this.headerMenuHeight) {
        this.headerMenuHeight = newHeight;
      }
    }
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

}
